import BusinessCasesList from './business-cases-list';

export default BusinessCasesList;
